
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import ProgressLinear from './ProgressLinear.vue'
@Component({
  components: {
    ProgressLinear,
  },
},
)
export default class CardTitle extends Vue {
  @Prop() private title!: string
}
